import { initExpLoader } from '@js-packages/experiment-loader';
import experiments from './configExtra.json';

initExpLoader({
    config: experiments,
    geoUrl: '/get_country_code',
    experimentInits: {
        tzPlatformLinks: () => import('./tzPlatformLinks/js/main.js'),
        propclick: () => import('./propclick/js/main.js'),
    },
});
